import { jsxs as v, jsx as a } from "react/jsx-runtime";
import * as d from "react";
import { u as H, c as I } from "../../../../index-DjWSt7QJ.js";
import { u as M, c as B, P as j } from "../../../../index-Bm60c36x.js";
import { u as q } from "../../../../index-BZPx6jYI.js";
import { u as z } from "../../../../index-BEuDtiQ6.js";
import { c as C } from "../../../../clsx-OuTLNxxd.js";
var S = "Switch", [A, Q] = B(S), [F, O] = A(S), P = d.forwardRef(
  (t, n) => {
    const {
      __scopeSwitch: e,
      name: c,
      checked: o,
      defaultChecked: l,
      required: r,
      disabled: s,
      value: h = "on",
      onCheckedChange: b,
      form: f,
      ...p
    } = t, [u, g] = d.useState(null), R = M(n, (m) => g(m)), _ = d.useRef(!1), k = u ? f || !!u.closest("form") : !0, [w = !1, E] = H({
      prop: o,
      defaultProp: l,
      onChange: b
    });
    return /* @__PURE__ */ v(F, { scope: e, checked: w, disabled: s, children: [
      /* @__PURE__ */ a(
        j.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": w,
          "aria-required": r,
          "data-state": N(w),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: h,
          ...p,
          ref: R,
          onClick: I(t.onClick, (m) => {
            E((T) => !T), k && (_.current = m.isPropagationStopped(), _.current || m.stopPropagation());
          })
        }
      ),
      k && /* @__PURE__ */ a(
        D,
        {
          control: u,
          bubbles: !_.current,
          name: c,
          value: h,
          checked: w,
          required: r,
          disabled: s,
          form: f,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
P.displayName = S;
var y = "SwitchThumb", x = d.forwardRef(
  (t, n) => {
    const { __scopeSwitch: e, ...c } = t, o = O(y, e);
    return /* @__PURE__ */ a(
      j.span,
      {
        "data-state": N(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...c,
        ref: n
      }
    );
  }
);
x.displayName = y;
var D = (t) => {
  const { control: n, checked: e, bubbles: c = !0, ...o } = t, l = d.useRef(null), r = q(e), s = z(n);
  return d.useEffect(() => {
    const h = l.current, b = window.HTMLInputElement.prototype, p = Object.getOwnPropertyDescriptor(b, "checked").set;
    if (r !== e && p) {
      const u = new Event("click", { bubbles: c });
      p.call(h, e), h.dispatchEvent(u);
    }
  }, [r, e, c]), /* @__PURE__ */ a(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: e,
      ...o,
      tabIndex: -1,
      ref: l,
      style: {
        ...t.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function N(t) {
  return t ? "checked" : "unchecked";
}
var L = P, U = x;
const i = {
  "switch-container": "_switch-container_116jj_29",
  "switch-disabled": "_switch-disabled_116jj_35",
  "switch-root": "_switch-root_116jj_35",
  "switch-thumb": "_switch-thumb_116jj_44",
  "switch-label": "_switch-label_116jj_78",
  "switch-title": "_switch-title_116jj_86",
  "switch-with-description": "_switch-with-description_116jj_90",
  "switch-description": "_switch-description_116jj_93"
}, V = ({
  id: t,
  label: n,
  onChange: e,
  description: c,
  value: o,
  defaultChecked: l,
  name: r,
  disabled: s,
  checked: h
}) => /* @__PURE__ */ v("div", { className: C(i["switch-container"], s && i["switch-disabled"]), children: [
  /* @__PURE__ */ v("label", { className: i["switch-label"], htmlFor: t, children: [
    /* @__PURE__ */ a("span", { className: C(i["switch-title"], c && i["switch-with-description"]), children: n }),
    c && /* @__PURE__ */ a("p", { className: i["switch-description"], children: c })
  ] }),
  /* @__PURE__ */ a(
    L,
    {
      className: i["switch-root"],
      id: t,
      checked: h,
      defaultChecked: l,
      onCheckedChange: e,
      value: o,
      name: r,
      "aria-label": r,
      disabled: s,
      children: /* @__PURE__ */ a(U, { className: i["switch-thumb"] })
    }
  )
] });
export {
  V as Switch
};
